<template>
  <div v-if="parameters">
    <h2>Parameters</h2>
    <v-btn :to="{name:'quoteParameterAdd'}">
      <v-icon>add</v-icon>Parameter
    </v-btn>
    <v-alert
      :value="true"
      type="info"
    >Excluding a parameter will make it unaffected by promotions removing it from the promotion manager. To set it to zero un-exclude it and set it to zero in the promotion.</v-alert>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="modifiedParameters"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{name:'quoteParameter', params:{id: props.item.id}}"
            >{{ props.item.id }}</router-link>
          </td>
          <td>
            <span v-if="props.item.parameterType">{{ props.item.parameterType.name }}</span>
            <span v-if="!props.item.parameterType">{{ props.item.parametertypeid }}</span>
          </td>
          <td>{{ props.item.value | toCurrency}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Parameters",
  metaInfo() {
    return {
      title: "Parameters",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    modifiedParameters() {
      if (!this.parameters) {
        return undefined;
      }
      const parameterTypesMap = this.parameterTypes
        ? convertListOfObjectsToMap(this.parameterTypes, "id")
        : undefined;
      return this.parameters.map(p => {
        const parameterType =
          parameterTypesMap && parameterTypesMap[p.parametertypeid]
            ? parameterTypesMap[p.parametertypeid]
            : undefined;
        return { ...p, parameterType };
      });
    }
  },
  data() {
    return {
      parameters: null,
      parameterTypes: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "parameterType.name"
        },
        {
          text: "Value",
          value: "value"
        }
      ],
      pagination: {
        rowsPerPage: 10
      }
    };
  },
  methods: {
    fetchParameters() {
      nbmlaw
        .get(`/cors/admin/sales/parameters`)
        .then(response => {
          // console.log(response.data);
          this.parameters = response.data;
        })
        .catch(() => {});
    },
    fetchParameterTypes() {
      nbmlaw
        .get(`/cors/admin/sales/parameterTypes`)
        .then(response => {
          // console.log(response.data);
          this.parameterTypes = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchParameters();
    this.fetchParameterTypes();
  }
};
</script>